export enum ProgramType {
    PROMOTION_PROGRAM = 'promotion_program',
    COMPANY_PROMOTION_PROGRAM = 'company_promotion_program',
    FREEBIE_PROGRAM = 'freebie_program',
    USER_PROMOTION_PROGRAM = 'user_promotion_program'
}
